import { Component, OnInit, Output, Input, EventEmitter } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "@app/_services";

interface ISearch {
  keyword: string;
  projectIds: Array<any>;
  endPointType: string;
  certified: boolean;
  subFlow: boolean;
}

@Component({
  selector: "app-endpoint-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.less"],
})
export class SearchComponent implements OnInit {
  endpointSearchForm: any;
  myProjects = [];
  endpointTypes: any;

  @Input() setForm: any;
  @Input() mobileTestCase: boolean;
  @Input() projectConfiguration;
  @Output() search: EventEmitter<any> = new EventEmitter();
  queryParams: any;

  endpointSortList = [
    { id: 'name', name: 'Name' },
    { id: 'updatedOn', name: 'Updated On' },
    { id: 'createdOn', name: 'Created On' },
  ];
  endpointSortOrder = "DESC";

  constructor(
    private formBuilder: FormBuilder,
    private cService: CommonService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.setFormValues();
    this.getMyProjects();

    this.endpointTypes = JSON.parse(
      localStorage.getItem("about")
    ).endPointTypes;

    this.route.queryParams.subscribe((params) => {
      let searchParams = JSON.parse(JSON.stringify(params));
      if(searchParams.default === undefined) {
        if(localStorage.getItem("defaultUserConfig") !== null && JSON.parse(localStorage.getItem("defaultUserConfig")).default_project) {
          searchParams.projectIds = [JSON.parse(localStorage.getItem("defaultUserConfig")).default_project];
        }
      } else {
        delete searchParams.default;
      }
      const filteredParams = this.filterParams(searchParams);
      this.setParamsToForm(filteredParams);
    });

    if (this.setForm) this.setParamsToForm(this.setForm);
  }

  getMyProjects() {
    this.cService.getMyProjects().subscribe((data) => {
      this.myProjects = data.response;
    });
  }

  setFormValues() {
    this.endpointSearchForm = this.formBuilder.group({
      keyword: [null],
      projectIds: [null],
      endPointType: [null],
      certified: [null],
      subFlow: [null],
      updatedBy: [null],
      createdBy: [null],
      sortBy : ['updatedOn'],
      direction: ['DESC']
    });
  }

  setParamsToForm(queryParams: any) {
    let form = this.endpointSearchForm;
    const query = JSON.parse(JSON.stringify(queryParams));

    Object.keys(queryParams)
      // .filter(this.filterQueryParams)
      .map((key) => {
        let keyVal = query[key];

        if (keyVal && key == "projectIds") {
          keyVal = Array.isArray(keyVal)
            ? keyVal.map(this.stringToInt)
            : [...[], this.stringToInt(keyVal)];
        }

        if (keyVal === "false" || keyVal === "true") keyVal = keyVal === "true";

        form.get(key).setValue(keyVal);
      });
  }

  onSubmit(data) {
    const form = this.endpointSearchForm.value;
    console.log("form.....", data.target.keyword.value)
    this.search.emit(form);
  }

  onClear() {
    const form = this.endpointSearchForm;
    form.reset();
    this.search.emit(form.value);
  }

  /* Additional functions */

  filterParams(params: any) {
    const clonedParams = JSON.parse(JSON.stringify(params));
    const filteredKeys = ["page", "size"];

    filteredKeys.forEach((key) => {
      delete clonedParams[key];
    });

    return clonedParams;
  }

  updateSortOrder(any) {
    this.endpointSortOrder = any;
    this.endpointSearchForm.get('direction').setValue(any);
  }

  stringToInt = (input: string) => parseInt(input);
}
